
namespace SorAraBul.Definitions {

    @Serenity.Decorators.registerClass()
    export class RestrictionsGrid extends Serenity.EntityGrid<RestrictionsRow, any> {
        protected getColumnsKey() { return RestrictionsColumns.columnsKey; }
        protected getDialogType() { return RestrictionsDialog; }
        protected getIdProperty() { return RestrictionsRow.idProperty; }
        protected getInsertPermission() { return RestrictionsRow.insertPermission; }
        protected getLocalTextPrefix() { return RestrictionsRow.localTextPrefix; }
        protected getService() { return RestrictionsService.baseUrl; }
        protected getIsActiveProperty() { return RestrictionsRow.isActiveProperty; }
        constructor(container: JQuery) {
            super(container);
        }
    }
}